'use client';
import React, { useState, useCallback } from 'react';
import { Search, X } from 'lucide-react';
import { usePublicStore } from './publicStore';

export default function PublicHero() {
  const { searchQuery, setSearchQuery } = usePublicStore();
  const [localQuery, setLocalQuery] = useState(searchQuery);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setLocalQuery(e.target.value);
      setSearchQuery(e.target.value);
    },
    [setSearchQuery]
  );

  const handleClear = useCallback(() => {
    setLocalQuery('');
    setSearchQuery('');
  }, [setSearchQuery]);

  return (
    <section className="bg-gradient-to-b from-blue-50 to-background pt-8 pb-6 sm:pt-12 sm:pb-8 px-4">
      <div className="max-w-screen-2xl mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          {/* Heading */}
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-foreground leading-tight mb-2">
            Find &amp; Download Official Forms
          </h1>
          <p className="text-sm sm:text-base text-muted-foreground mb-6">
            Search by form name, category, or keyword — then download and print.
          </p>

          {/* Search bar */}
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <Search size={18} className="text-muted-foreground" aria-hidden="true" />
            </div>
            <input
              type="search"
              value={localQuery}
              onChange={handleChange}
              placeholder="Search for a form... e.g. leave, refund, bonafide"
              aria-label="Search forms"
              className="w-full pl-11 pr-12 py-3.5 sm:py-4 text-sm sm:text-base bg-card border-2 border-border rounded-xl shadow-sm focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all duration-150 text-foreground placeholder:text-muted-foreground"
            />
            {localQuery && (
              <button
                onClick={handleClear}
                aria-label="Clear search"
                className="absolute inset-y-0 right-0 pr-4 flex items-center text-muted-foreground hover:text-foreground transition-colors"
              >
                <X size={16} />
              </button>
            )}
          </div>

          {/* Quick search hints */}
          <div className="flex flex-wrap justify-center gap-2 mt-3">
            {['Leave', 'Refund', 'Bonafide', 'Scholarship', 'Revaluation'].map((hint) => (
              <button
                key={`hint-${hint}`}
                onClick={() => {
                  setLocalQuery(hint);
                  setSearchQuery(hint);
                }}
                className="px-3 py-1 text-xs font-medium bg-card border border-border rounded-full text-muted-foreground hover:text-primary hover:border-primary transition-all duration-150"
              >
                {hint}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}